'use strict';

/**
 * Reward Loyalty - Proprietary Software
 * Copyright (c) 2025 NowSquare. All rights reserved.
 * See LICENSE file for terms.
 */

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
 
window.Alpine = Alpine;

Alpine.plugin(collapse);

Alpine.start();